// 16 fest gebundelte IT-Beratungs-Icons. Diese sind im Default-Grid des IconPickers
// immer sichtbar. Long-Tail wird via Lazy-Search aus dem vollstaendigen lucide-react
// nachgeladen.
//
// Quelle: lucide.dev — Icon-Namen MUESSEN exakt zu den lucide-react-Komponenten passen.

export const ICON_DEFAULT_NAMES = [
  "User",
  "Users",
  "UserCheck",
  "AlertTriangle",
  "CheckCircle",
  "XCircle",
  "Server",
  "Database",
  "Cloud",
  "Globe",
  "Lock",
  "Lightbulb",
  "Flag",
  "Star",
  "Building",
  "GitBranch",
] as const;

export type IconDefaultName = (typeof ICON_DEFAULT_NAMES)[number];

/** Suche-Tags pro Default-Icon (DE + EN). Wird vom Picker-Search-Filter genutzt
 *  damit User mit "person", "warnung", "datenbank" etc. trifft. */
export const ICON_DEFAULT_TAGS: Record<IconDefaultName, readonly string[]> = {
  User: ["user", "person", "akteur", "stakeholder", "human", "profile"],
  Users: ["users", "team", "group", "personen"],
  UserCheck: ["user-check", "verified", "approved", "zugelassen"],
  AlertTriangle: ["alert", "warning", "warnung", "risk", "achtung"],
  CheckCircle: ["check", "done", "erledigt", "ok", "approved"],
  XCircle: ["x", "fail", "error", "fehler", "fehlgeschlagen"],
  Server: ["server", "host", "system", "backend"],
  Database: ["database", "db", "datenbank", "storage", "store"],
  Cloud: ["cloud", "wolke", "saas"],
  Globe: ["globe", "world", "welt", "international", "www"],
  Lock: ["lock", "security", "sicherheit", "schloss"],
  Lightbulb: ["idea", "lightbulb", "idee", "innovation"],
  Flag: ["flag", "milestone", "ziel", "meilenstein"],
  Star: ["star", "favorit", "wichtig", "highlight"],
  Building: ["building", "company", "office", "gebaeude", "firma"],
  GitBranch: ["branch", "fork", "version", "abzweigung"],
};

export function searchDefaults(query: string): IconDefaultName[] {
  if (!query.trim()) return [...ICON_DEFAULT_NAMES];
  const q = query.toLowerCase();
  return ICON_DEFAULT_NAMES.filter((name) => {
    if (name.toLowerCase().includes(q)) return true;
    return ICON_DEFAULT_TAGS[name].some((t) => t.includes(q));
  });
}
